import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TaskFormTemplate } from '@/templates/BossBaby';
import { useBossBabyTasks } from '@/hooks/useBossBaby';
import { CreateBossBabyTaskDto } from '@/dto/BossBabyDto';
import { Container } from '@mui/material';

export const TaskCreate: React.FC = () => {
  const navigate = useNavigate();
  const { createTask } = useBossBabyTasks();

  const handleSubmit = async (data: CreateBossBabyTaskDto) => {
    try {
      await createTask(data);
    } catch (error) {
      console.error('Create task error:', error);
    }
  };

  const handleCancel = () => {
    navigate('/boss-baby/tasks');
  };

  return (
    <Container>
      <TaskFormTemplate
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isEdit={false}
      />
    </Container>
  );
};